<div class="cardLayout">
  <ion-row>
    <ion-col size="10">
      <div class="formLabelSemiBoldfs16 mb-5">{{operation == 'Add'?'Add New':'Edit'}} KPI</div>
    </ion-col>
    <ion-col size="2" class="text-right">
      <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
    </ion-col>
  </ion-row>
  <form [formGroup]="editKPIInformationForm">
    <ion-row>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">KRA<span class="red-cl">&nbsp;*</span></div>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input formControlName="kra" [attr.readonly]="isFieldsDisabled ? false: true" [disabled]="isFieldsDisabled"
            [ngClass]="{'notAllowed' : isFieldsDisabled}" matInput placeholder="Type text here" class="font_regular">
          <mat-error *ngIf="editKPIInformationForm.controls['kra'].hasError('required')">KRA is required</mat-error>
          <mat-error *ngIf="editKPIInformationForm.get('kra')?.hasError('maxlength')">
            Maximum 255 characters allowed
          </mat-error>
        </mat-form-field>
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">My KPI<span class="red-cl">&nbsp;*</span></div>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input [attr.readonly]="isFieldsDisabled ? false: true" [disabled]="isFieldsDisabled"
            [ngClass]="{'notAllowed' : isFieldsDisabled}" matInput formControlName="kpi" placeholder="Type text here"
            class="font_regular">
          <mat-error *ngIf="editKPIInformationForm.controls['kpi'].hasError('required')">My KPI is required</mat-error>
          <mat-error *ngIf="editKPIInformationForm.get('kpi')?.hasError('maxlength')">
            Maximum 255 characters allowed
          </mat-error>
        </mat-form-field>
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">{{sharedService.transform(selectedYearReviewCycle)}}<span
            class="red-cl">&nbsp;*</span></div>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <mat-select [attr.readonly]="isFieldsDisabled ? false: true" [disabled]="isFieldsDisabled"
            placeholder="Select" formControlName="month"
            (selectionChange)="checkUserByDojAndDoe();checkPMSSetup();getWeightage()">
            <mat-option *ngFor="let item of getMonthsByFiscalandReviewCycle"
              [value]="item">{{sharedService.transform(item)}}</mat-option>
          </mat-select>
          <mat-error *ngIf="editKPIInformationForm.controls['month'].hasError('required')">Duration is
            required</mat-error>
        </mat-form-field>
        <div class="fs-12 font_regular red-cl" *ngIf="!isUserValidToAddKPI && editKPIInformationForm.value.month!=null">
          Your DOJ Month is {{dojMonth}}. You can add KPIs between DOJ and DOE only
        </div>
        <div class="fs-12 font_regular red-cl" *ngIf="isCuttofDateActive && editKPIInformationForm.value.month!=null">
          Your Cut off date is Over You cant add the KPIs</div>

      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">Lesser is Better<span class="red-cl">&nbsp;*</span></div>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <mat-select [attr.readonly]="isFieldsDisabled ? false: true" [disabled]="isFieldsDisabled"
            placeholder="Select" formControlName="lesserIsBetter" (selectionChange)="calculateAchievement()">
            <mat-option [value]="true">Yes</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
          <mat-error *ngIf="editKPIInformationForm.controls['lesserIsBetter'].hasError('required')">Lesser is Better is
            required</mat-error>
        </mat-form-field>
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">Milestone From</div>
        <ng-select placeholder="Select" (change)="getToMonths(editKPIInformationForm.value.milestoneFrom)"
          formControlName="milestoneFrom" [readonly]="isFieldsDisabled" [disabled]="isFieldsDisabled">
          <ng-option [value]="item" *ngFor="let item of getMonthsForMilestoneFrom">{{item}}</ng-option>
        </ng-select>
        <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select [attr.readonly]="isFieldsDisabled ? false: true" [disabled]="isFieldsDisabled" placeholder="Select" formControlName="milestoneFrom">
                <mat-option *ngFor="let item of getMonthsForMilestoneFrom" [value]="item">{{sharedService.transform(item)}}</mat-option>
            </mat-select>
        </mat-form-field> -->
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">Milestone To<span
            *ngIf="editKPIInformationForm.value?.milestoneFrom != null" class="red-cl">&nbsp;*</span></div>
        <ng-select placeholder="Select" formControlName="milestoneTo" [readonly]="isFieldsDisabled"
          [disabled]="isFieldsDisabled">
          <ng-option [value]="item" *ngFor="let item of getMonthsForMilestoneTo">{{item}}</ng-option>
        </ng-select>
        <label *ngIf="addFormSubmitted && editKPIInformationForm.value?.milestoneTo == null"
          class="fs-12 font_regular red-cl">Milestone To is required</label>
        <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select [attr.readonly]="isFieldsDisabled ? false: true" [disabled]="isFieldsDisabled" placeholder="Select" formControlName="milestoneTo">
              <mat-option *ngFor="let item of getMonthsForMilestoneTo" [value]="item">{{sharedService.transform(item)}}</mat-option>
            </mat-select>
        </mat-form-field> -->
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">Weightage (%)<span class="red-cl">&nbsp;*</span></div>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input [attr.readonly]="isFieldsDisabled ? false: true" [ngClass]="{'notAllowed' : isFieldsDisabled}"
            [disabled]="isFieldsDisabled" formControlName="weightage" type="number" maxlength="3" matInput
            placeholder="Type number here" class="font_regular" (input)="getWeightage();calculateAchievement()">
          <mat-error *ngIf="editKPIInformationForm.controls['weightage'].hasError('required')">Weightage (%) is
            required</mat-error>
          <mat-error *ngIf="editKPIInformationForm.controls['weightage'].hasError('negativeNumber')">Weightage cannot be
            negative</mat-error>
        </mat-form-field>
        <label *ngIf="invalidReviewCycleWeightage" class="fs-12 font_regular red-cl">Total Weightage (%) should not be
          more than 100</label>
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">Target<span class="red-cl">&nbsp;*</span></div>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input [attr.readonly]="isFieldsDisabled ? false: true" [ngClass]="{'notAllowed' : isFieldsDisabled}"
            [disabled]="isFieldsDisabled" (input)="calculateAchievement()" formControlName="target" matInput
            type="number" placeholder="Type number here" class="font_regular">
          <mat-error *ngIf="editKPIInformationForm.controls['target'].hasError('required')">Target is
            required</mat-error>
        </mat-form-field>
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs16 mb-5">UOM<span class="red-cl">&nbsp;*</span></div>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input [attr.readonly]="isFieldsDisabled ? false: true" [ngClass]="{'notAllowed' : isFieldsDisabled}"
            [disabled]="isFieldsDisabled" matInput placeholder="Type text here" class="font_regular"
            formControlName="uom">
          <mat-error *ngIf="editKPIInformationForm.controls['uom'].hasError('required')">UOM is required</mat-error>
        </mat-form-field>
      </ion-col>
      <ng-container *ngIf="goalApprovalStatus">
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Actual</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input type="number" matInput placeholder="Type number here" class="font_regular" formControlName="actual"
              (input)="calculateAchievement()">
            <mat-error *ngIf="editKPIInformationForm.controls['actual'].hasError('required')">Actual is
              required</mat-error>
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">% Achievement</div>
          <div class="inputBox notAllowed" *ngIf="((editKPIInformationForm.value.target > 0 || editKPIInformationForm.value.target == 0)
            && (editKPIInformationForm.value.actual > 0 || editKPIInformationForm.value.actual == 0)) ||
            ((editKPIInformationForm.value.target < 0 || editKPIInformationForm.value.target == 0)
            && (editKPIInformationForm.value.actual < 0 || editKPIInformationForm.value.actual == 0)
            || editKPIInformationForm.value.actual == null)">
            {{editKPIInformationForm.value.percentageAchievement}}
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style" *ngIf="(editKPIInformationForm.value.target < 0 && editKPIInformationForm.value.actual > 0) ||
          (editKPIInformationForm.value.target > 0 && editKPIInformationForm.value.actual < 0)">
            <input type="number" matInput placeholder="Type number here" class="font_regular"
              formControlName="percentageAchievement" (input)="calculateAchievement()">
            <mat-error *ngIf="editKPIInformationForm.controls['percentageAchievement'].hasError('required')">%
              Achievement is required</mat-error>
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">KPI Score</div>
          <div class="inputBox notAllowed">{{editKPIInformationForm.value.kpiScore || ''}}</div>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Employee Comment</div>
          <div class="textAreaBox notAllowed" *ngIf="selectedTab === 'Team Goals'">
            {{editKPIInformationForm.value.employeeComment}}</div>
          <mat-form-field class="w-100 mat-input-style"
            *ngIf="selectedTab === 'My Goals' || selectedTab === 'Employee Goals'">
            <textarea (ngModelChange)="checkLengthOfField(editKPIInformationForm.value.employeeComment)"
              [attr.readonly]="selectedTab === 'Team Goals' ? true : null"
              [ngClass]="{'notAllowed' : selectedTab === 'Team Goals'}" [disabled]="selectedTab === 'Team Goals'"
              matInput placeholder="Type text here" formControlName="employeeComment"></textarea>
            <!-- <mat-error *ngIf="editKPIInformationForm.controls['employeeComment'].hasError('required')">Employee Comment is required</mat-error> -->
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Manager Comment</div>
          <div class="textAreaBox notAllowed" *ngIf="selectedTab === 'My Goals'">
            {{editKPIInformationForm.value.managerComment}}</div>
          <mat-form-field class="w-100 mat-input-style"
            *ngIf="selectedTab === 'Team Goals' || selectedTab === 'Employee Goals'">
            <textarea (ngModelChange)="checkLengthOfField(editKPIInformationForm.value.managerComment)"
              [attr.readonly]="selectedTab === 'My Goals'? true : null"
              [ngClass]="{'notAllowed' : selectedTab === 'My Goals'}" [disabled]="selectedTab === 'My Goals'" matInput
              placeholder="Type text here" formControlName="managerComment"></textarea>
            <!-- <mat-error *ngIf="editKPIInformationForm.controls['managerComment'].hasError('required')">Manager Comment is required</mat-error> -->
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">MIS Attachment</div>

          <div
            *ngIf="(editKPIInformationForm.value.misAttachment?.length !== 0 && editKPIInformationForm.value.misAttachment!== null )">
            <!-- (click)="downloadMisFile(editKPIInformationForm.value.misAttachment,editKPIInformationForm.value.misFileName)"> -->
            <span class="cp link"
              (click)="misPriview(editKPIInformationForm.value.misAttachment,editKPIInformationForm.value.misFileName)">


              
           <span class="mt-20">See Attachment</span>

            </span>
            <img src="././assets/icon/remove.png" class="removeIcon cp" (click)="onRemovemisAttachment()">
          </div>
          <!-- Upload Box -->
          <div *ngIf="(!editKPIInformationForm.value.misAttachment || editKPIInformationForm.value.misAttachment?.length === 0) 
          || !editKPIInformationForm.value.misFileName" class="mt-0 upload-Contractbox display-center pt-25 pb-25">

            <div class="d-flex">
              <label (click)="browseImage.click()" class="link text_center font_regular cp">
                Upload MIS Attachment
              </label>
              <input #browseImage type="file" style="display:none;" (change)="uploadImage($event)" multiple
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png" />
            </div>

            <label class="font_italic fs-14 fs_12ForMobile gray_color fs-12ForMobileView">
              File size should be less than 10MB
            </label>
          </div>

          <!-- Loader -->
          <div *ngIf="isLoading" class="loader-overlay">
            <div class="spinner"></div>
            <p>Uploading...</p>
          </div>

        </ion-col>
      </ng-container>

    </ion-row>
  </form>
  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-right mt-10 d-flex">
      <button (click)="closeDialog()" class="back_btn fs-14 fs_12ForMobile">Cancel</button>
      <button *ngIf="operation == 'Add'" (click)="addGoalSetting()" type="button"
        class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName">Add</button>
      <button *ngIf="operation == 'Edit'" (click)="editGoalSetting()" type="button"
        class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName">Update</button>
    </ion-col>
  </ion-row>
  <div class="clear20"></div>
</div>